import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'tags'
const verb = 'get'

export default class OspreyTagSearch extends BaseAction {
    constructor(dataKey) {
        const id = 'trb92b92-82b3-40ea-a150-25e514edfa6b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/tags/tags-search.js